// extracted by mini-css-extract-plugin
export default {"container":"HeroCarousel_container__+wzMq","arrow":"HeroCarousel_arrow__EFTrq","arrowLeft":"HeroCarousel_arrowLeft__rOszk","arrowRight":"HeroCarousel_arrowRight__CRxQT"};